import { Outlet, RouteObject } from "react-router-dom";
import WelcomePage from "../pages/welcomePage";
import { DomainProvider } from "@4uhub/lib4uhub";
import RegisterCampaignsPage from "../pages/4uMarCom/Campaigns/RegisterCampaigns/RegisterCampaignsPage";
import RegisterCampaign from "../pages/4uMarCom/Campaigns/RegisterCampaigns/RegisterCampaignForm/RegisterCampaign";
import CommunicationPermissionsPage from "../pages/4uMarCom/OptInOptOut/CommunicationPermissions/CommunicationPermissionsPage";
import AutomationRulesMarComPage from "../pages/4uMarCom/AutomationRulesMarcom/AutomationRulesMarComPage";
import AutomationRulesMarCom from "../pages/4uMarCom/AutomationRulesMarcom/AutomationRulesMarComForm/AutomationRulesMarCom";
import { Whatsapp4uMarComPage } from "../pages/4uMarCom/Whatsapp4uMarCom/Whatsapp4uMarComPage";
import { Whatsapp4uMarCom } from "../pages/4uMarCom/Whatsapp4uMarCom/Whatsapp4uMarComForm/Whatsapp4uMarCom";

const marcomRoutes: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "campaign",
    element: <Outlet />,
    children: [
      {
        path: "campaignRegister",
        element: (
          <DomainProvider value={{ domainName: "campaign" }}>
            <RegisterCampaignsPage />
          </DomainProvider>
        ),
      },
      {
        path: "campaignRegister/new",
        element: (
          <DomainProvider value={{ domainName: "campaign" }}>
            <RegisterCampaign />
          </DomainProvider>
        ),
      },
      {
        path: "campaignRegister/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "campaign" }}>
            <RegisterCampaign />
          </DomainProvider>
        ),
      },
    ],
  },
  {
    path: "templates",
    element: <Outlet />,
    children: [
      {
        path: "whatsapp",
        element: (
          <DomainProvider value={{ domainName: "campaign" }}>
            <Whatsapp4uMarComPage />
          </DomainProvider>
        ),
      },
      {
        path: "whatsapp/new",
        element: (
          <DomainProvider value={{ domainName: "campaign" }}>
            <Whatsapp4uMarCom />
          </DomainProvider>
        ),
      },
      {
        path: "whatsapp/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "campaign" }}>
            <Whatsapp4uMarCom />
          </DomainProvider>
        ),
      },
    ],
  },
  {
    path: "automations",
    element: <Outlet />,
    children: [
      {
        path: "automationRule",
        element: (
          <DomainProvider value={{ domainName: "marcomautomationrule" }}>
            <AutomationRulesMarComPage />
          </DomainProvider>
        ),
      },
      {
        path: "automationRule/new",
        element: (
          <DomainProvider value={{ domainName: "marcomautomationrule" }}>
            <AutomationRulesMarCom />
          </DomainProvider>
        ),
      },
      {
        path: "automationRule/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "marcomautomationrule" }}>
            <AutomationRulesMarCom />
          </DomainProvider>
        ),
      },
    ],
  },
  {
    path: "optInOptOut",
    element: <Outlet />,
    children: [
      {
        path: "permissionCommunication",
        element: (
          <DomainProvider value={{ domainName: "marcomoptinout" }}>
            <CommunicationPermissionsPage />
          </DomainProvider>
        ),
      },
    ],
  },
];

export default marcomRoutes;
